<div class="custom-loader-overlay" [class.visible]="isVisible">
  <div class="loader-container">

    <!-- Main Loader Animation -->
    <div class="spinner-container">
      <div class="spinner">
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
      </div>
    </div>

    <!-- Progress Bar -->
    <div class="progress-container" *ngIf="showProgress">
      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>
    </div>

    <!-- Loading Text -->
    <div class="loading-text-container">
      <p class="loading-text">{{ loadingText }}<span class="loading-dots">{{ loadingDots }}</span></p>
      <p class="loading-subtitle">Please wait while we prepare everything for you</p>
    </div>

    <!-- Floating Elements -->
    <div class="floating-elements">
      <div class="float-element float-1"></div>
      <div class="float-element float-2"></div>
      <div class="float-element float-3"></div>
      <div class="float-element float-4"></div>
    </div>

  </div>
</div>
